import { Injectable } from '@angular/core';
import { RelayModel } from '@rift/models/restapi/Relay.Model';
import { ResultModel } from '@rift/models/restapi/Result.Model';
import { RiftBaseService } from '@rift/service/base/RiftBase.Service';
import { RestApiRelaysService } from '@rift/service/restapi/v1/RestApi.Relays.Service';
import { ObservableTracker } from '@shared/generic/ObservableLoading';
import { ProcessMonitorServiceProcess } from '@shared/service/processmonitor/ProcessMonitor.Service.Process';
import { isNullOrUndefined } from '@shared/utility/General.Utility';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class RelayService extends RiftBaseService {

    private _getSettingsLoadingTracker = new ObservableTracker<RelayModel>();
    private _relayCache: RelayModel;
    private _setSettingsLoadingTracker = new ObservableTracker<ResultModel>();

    public constructor(
        private readonly _restApiRelaysService: RestApiRelaysService) {
        super();
    }

    public clearCache(): void {
        this.clearObservableTrackers();
        this._relayCache = null;
    }
    public getSettings(process?: ProcessMonitorServiceProcess): Observable<RelayModel> {
        if (isNullOrUndefined(this._relayCache)) {
            return this._getSettingsLoadingTracker
                .getLoading()
                .observable(this._restApiRelaysService.getSettings(process).pipe(
                    map(result => {
                        this._relayCache = result;
                        return this._relayCache;
                    })
                ));
        } else {
            return of(this._relayCache);
        }
    }

    public setCache(relayCache: RelayModel): Observable<boolean> {
        this._relayCache = relayCache;
        return of(true);
    }

    public setSettings(settings: RelayModel, process?: ProcessMonitorServiceProcess): Observable<ResultModel> {
        return this._setSettingsLoadingTracker
            .getLoading(settings)
            .observable(this._restApiRelaysService.setSettings(settings, process));
    }
}
